/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DiagnosisClassificationEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY'
} as const;
export type DiagnosisClassificationEnum = typeof DiagnosisClassificationEnum[keyof typeof DiagnosisClassificationEnum];

